<template>
  <div class="m-15">
    <b-row>
      <b-col cols="12" lg="6" class="mt-3">
        <table class="update-table">
          <tbody>
            <tr>
              <td class="mw67">
                <c-switch
                  class="mx-1"
                  v-model="havePush"
                  color="success"
                  checked
                  variant="3d"
                  @change="onChangePush"
                />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Enviar push</strong>
                </span>
              </td>
            </tr>
            <tr>
              <td class="mw67">
                <c-switch
                  class="mx-1"
                  v-model="haveEmail"
                  color="primary"
                  checked
                  variant="3d"
                  disabled
                />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Enviar email</strong>
                </span>
              </td>
            </tr>
            <tr class="animated fadeIn" v-bind:class="{ display: !haveEmail }">
              <td class="mw67">
                <c-switch class="mx-1" color="primary" checked variant="3d" />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Todos os clientes</strong>
                </span>
              </td>
              <td class="mw67">
                <c-switch class="mx-1" color="primary" checked variant="3d" />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Envio importante</strong>
                </span>
              </td>
            </tr>
            <tr>
              <td class="mw67">
                <c-switch
                  class="mx-1"
                  color="secondary"
                  v-model="haveEmail"
                  disabled
                  checked
                  variant="3d"
                />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Enviar SMS</strong>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col cols="12" lg="6" class="mt-3">
        <h5>Configurações</h5>
        <b-col cols="12">
          <b-input-group prepend="Título">
            <b-form-input
              v-model="titulo"
              placeholder="ex: Promoção - Item com 10% de desconto"
              @change="onChanged"
            />
          </b-input-group>
        </b-col>
        <b-col cols="12">
          <b-input-group prepend="Descrição" class="mt-3">
            <b-form-input
              v-model="descricao"
              placeholder="ex: Válido por X dias"
              @change="onChanged"
            />
          </b-input-group>
        </b-col>
        <b-col cols="12" lg="6" class="mt-3">
          <table>
            <tr>
              <td class="mw67">
                <c-switch
                  class="mx-1"
                  v-model="showText"
                  color="success"
                  checked
                  variant="3d"
                  @change="onChangeShowText"
                />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Exibir Título e Descrição no App</strong>
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import { Switch as cSwitch } from "@coreui/vue";
import * as config from "@/config.json";
import store from "../../../store";

export default {
  name: "inserirpromocaoconfiguracoes",
  components: {
    cSwitch,
  },
  data: function () {
    return {
      havePush: false,
      haveEmail: false,
      titulo: "",
      descricao: "",
      showText: false,
      store,
    };
  },
  methods: {
    setLocalStorage() {
      localStorage.setItem("titulo", this.titulo);
      localStorage.setItem("descricao", this.descricao);
    },
    onChanged() {
      if (this.titulo != "" && this.descricao != "") {
        this.setLocalStorage();
        this.$emit("can-continue", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    onChangePush() {
      localStorage.setItem("have-push", this.havePush);
    },
    onChangeShowText() {
      localStorage.setItem("show-text", this.showText);
    },
  },
  mounted() {
    localStorage.setItem("have-push", false);
    localStorage.setItem("show-text", false);
    this.havePush = false;
    this.haveEmail = false;
    this.showText = false;
  },
};
</script>
